import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Marquee from "../components/Marquee"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
export default class Featured extends Component {
  constructor(obj) {
    super(obj)

    this.marqueeDOM = qs(".marquee", this.el)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })
  }

  on() {
    this.marquee = new Marquee(this.marqueeDOM)
  }

  resize() {
    this.marquee.resize()
  }

  animate() {
    const title = qsa(".title-desktop .char-1", this.el)
    const items = qsa(".list-item", this.el)
    const borders = qsa(".border", this.el)

    const lines = qsa(".line-0", this.el)
    lines.forEach(line => {
      line.style.overflow = "hidden"
    })

    gsap.from(title, {
      y: "100%",
      stagger: 0.05,
      duration: 1.2,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    items.forEach((item, i) => {
      const chars = qsa(".char-1", item)

      gsap.from(chars, {
        y: "100%",
        duration: 1.2,
        stagger: 0.07,
        delay: i * 0.01,
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
        },
      })
    })

    borders.forEach(border => {
      gsap.from(border, {
        scaleX: 0,
        duration: 1.2,
        scrollTrigger: {
          trigger: border,
          start: "top bottom",
        },
      })
    })
  }
}
